/* ─────────────────────────────────────────────────────────────────────────
   Main product behaviours.
   - Gallery view switching ([data-view] thumbs → [data-view-panel] stages)
   - Variant select → price / availability updates + gallery swap when the
     variant has a featured media (lean JSON map in [data-product-json])
   - Add-to-bag via window.PavosCart.add (FormData), with "Added" flash
   - Sticky mobile CTA submits the same form (form="" attribute)
   ──────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var ADDED_FLASH_MS = 2000;

  /* Activate one gallery view by its [data-view-panel] id and sync the
     matching thumbnail's active state. Shared by thumb clicks and variant
     changes. */
  function activateView(root, id) {
    var panels = root.querySelectorAll('[data-view-panel]');
    var thumbs = root.querySelectorAll('[data-view]');
    panels.forEach(function (panel) {
      var active = panel.getAttribute('data-view-panel') === id;
      panel.classList.toggle('is-active', active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    thumbs.forEach(function (thumb) {
      var active = thumb.getAttribute('data-view') === id;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /* Swap the gallery stage to a variant's featured media. Prefers the photo
     panel rendered for that exact media id; otherwise retargets the first
     photo panel's <img>. No-ops gracefully when the gallery only has
     synthetic candle-visual views and no photo panel exists. */
  function showVariantMedia(root, media) {
    if (!media || !media.src) return;
    var target = root.querySelector(
      '[data-view-panel][data-media-id="' + media.id + '"]'
    );
    if (!target) {
      target = root.querySelector('.pdp__view--photo');
      if (!target) return;
      var img = target.querySelector('img');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = media.src;
        if (media.alt) img.alt = media.alt;
      }
    }
    activateView(root, target.getAttribute('data-view-panel'));
  }

  function readVariantData(root) {
    var el = root.querySelector('[data-product-json]');
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-view]');
    var panels = root.querySelectorAll('[data-view-panel]');
    if (!thumbs.length || !panels.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateView(root, thumb.getAttribute('data-view'));
      });
    });
  }

  function initVariants(root) {
    var select = root.querySelector('[data-variant-select]');
    if (!select) return;

    var variants = readVariantData(root);
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var stickyPriceEl = root.querySelector('[data-sticky-price]');
    var buttons = root.querySelectorAll('[data-add-to-cart]');

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (!option) return;

      if (priceEl && option.dataset.price) {
        priceEl.textContent = option.dataset.price;
      }
      if (stickyPriceEl && option.dataset.price) {
        stickyPriceEl.textContent = option.dataset.price;
      }
      if (compareEl) {
        if (option.dataset.compare) {
          compareEl.querySelector('s').textContent = option.dataset.compare;
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', 'hidden');
        }
      }

      var available = option.dataset.available !== 'false';
      buttons.forEach(function (btn) {
        btn.disabled = !available;
        btn.textContent = available
          ? btn.getAttribute('data-label')
          : btn.getAttribute('data-soldout-label');
      });

      /* Gallery follows the variant when it has its own media. */
      var variant = null;
      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === select.value) {
          variant = variants[i];
          break;
        }
      }
      if (variant && variant.featured_media) {
        showVariantMedia(root, variant.featured_media);
      }
    });
  }

  function initForm(root) {
    var form = root.querySelector('[data-product-form]');
    if (!form) return;

    var buttons = root.querySelectorAll('[data-add-to-cart]');
    var timer = null;

    function flashAdded() {
      buttons.forEach(function (btn) {
        btn.textContent = btn.getAttribute('data-added-label');
      });
      clearTimeout(timer);
      timer = setTimeout(function () {
        buttons.forEach(function (btn) {
          if (!btn.disabled) btn.textContent = btn.getAttribute('data-label');
        });
      }, ADDED_FLASH_MS);
    }

    form.addEventListener('submit', function (event) {
      if (!window.PavosCart || typeof window.PavosCart.add !== 'function') {
        return; /* no helper — let the form post to /cart/add natively */
      }
      event.preventDefault();

      buttons.forEach(function (btn) { btn.disabled = true; });

      window.PavosCart.add(new FormData(form))
        .then(function () {
          buttons.forEach(function (btn) { btn.disabled = false; });
          flashAdded();
        })
        .catch(function () {
          buttons.forEach(function (btn) {
            btn.disabled = false;
            btn.textContent = btn.getAttribute('data-label');
          });
        });
    });
  }

  function initSection(root) {
    if (!root || root.hasAttribute('data-pdp-ready')) return;
    root.setAttribute('data-pdp-ready', '');
    initGallery(root);
    initVariants(root);
    initForm(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pdp]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
